'use strict';

const saStateClass = [
  '$rootScope',

  function ($rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, $element) {
        var addedClass;

        function updateClass(cssClass) {
          $element.removeClass(addedClass);
          addedClass = null;

          if (cssClass) {
            $element.addClass(cssClass);
            addedClass = cssClass;
          }
        }

        $rootScope.$on('$stateChangeSuccess', function (event, newState) {
          updateClass(newState.data && newState.data.cssClass);
        });
      }
    };
  }
];

export default saStateClass;



// WEBPACK FOOTER //
// ./app/src/directives/state_class.js